HuesMdl.filter('thumb',function() {
	return function(input) {
		if (input) {
			return input.replace(/.([^.]*)$/, "-180x180.$1");
		}
	}
});